import {useLayoutEffect, useState} from 'react';
import {
    setIsSmallScreenLayout,
    selectIsSmallScreenLayout,
    setIsCartOverlayLayout,
    selectIsCartOverlayLayout,
} from 'store/customer/UISlice';
import {useSidebarBehaviour} from 'hooks/SidebarUIHook';
import {
    isCartOverlayLayout as isCartOverlayLayoutCheck,
    isDeviceSmall,
    isSidebarOverlayLayout,
} from 'shared/helpers/DeviceSize';
import {useAppDispatch, useAppSelector} from 'store/customer';

const useUI = () => {
    const dispatch = useAppDispatch();
    const isSmallScreenLayout = useAppSelector(selectIsSmallScreenLayout);
    const isCartOverlayLayout = useAppSelector(selectIsCartOverlayLayout);
    const isSmallDevice = isDeviceSmall();
    const [layoutEffectDone, setLayoutEffectDone] = useState(false);

    useLayoutEffect(() => {
        if (isSidebarOverlayLayout()) {
            dispatch(setIsSmallScreenLayout(true));
        }
        if (isCartOverlayLayoutCheck()) {
            dispatch(setIsCartOverlayLayout(true));
        }
        setLayoutEffectDone(true);
    }, [isSmallDevice]);

    const {
        alternateCartContent,
        leftSidebar,
        rightSidebar,
        leftSidebarBehaviour,
        rightSidebarBehaviour,
        setLeftSidebar,
        setRightSidebar,
        setLeftSidebarBehaviour,
        setRightSidebarBehaviour,
        setAlternateCartContent,
    } = useSidebarBehaviour();

    return {
        alternateCartContent,
        leftSidebar,
        rightSidebar,
        leftSidebarBehaviour,
        rightSidebarBehaviour,
        setLeftSidebar,
        setRightSidebar,
        setLeftSidebarBehaviour,
        setRightSidebarBehaviour,
        setAlternateCartContent,
        isSmallScreenLayout,
        isCartOverlayLayout,
        layoutEffectDone,
    };
};

export default useUI;
